<ion-header #header>
    <leplace-toolbar [menu]="false" [title]="title" [leftButton]="appIconsStandard.home" [leftButtonDisabled]="linkPreview"
        [leftIcon]="true" (leftClick)="back()" rightButton="settings" [rightIcon]="true" (rightClick)="presentPopover()"
        [loading]="false">
    </leplace-toolbar>
</ion-header>

<!-- overflow-scroll="true" -->

<ion-content [ngClass]="theme" #content>
    <!-- (swipe)="swipeEvent($event)" -->
    <div class="view-frame view-frame-border">
        <!-- bg-filter-1 -->
        <div class="bg-container bg-container-fill"
            [photoBg]="{fade: true, fadeClass: 'bg-container-fade', url: photoUrl}">

            <div class="content text-color-overlay">

                <div *ngIf="!loaded" class="progress-spinner-center">
                    <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </div>

                <div *ngIf="loaded" fxLayout="column" class="content-height no-scroll">

                    <div class="scrollbar-y content-height" fxLayout="column" (scroll)='onContentScroll($event)'>

                        <div [innerHTML]="validationMessage"
                            class="info-text-lg bold description-frame text-color-primary text-center margin-s">
                        </div>

                        <ion-row>
                            <ion-col class="padding-s center-text">
                                <span class="center-text info-text-mlg bold text-color-primary">Experience App-Guided
                                    Tours</span>
                            </ion-col>
                        </ion-row>

                        <div *ngIf="tutorialVideoUrl" class="margin-s">
                            <youtube-view [videoUrl]="tutorialVideoUrl" customClass="video-landscape"></youtube-view>
                        </div>

                        <!-- text-color-overlay-flush  -->

                        <div class="margin-horizontal-s margin-top-m margin-bottom-s" *ngIf="extDataLoaded">
                            <div class="text-left">
                                <div class="center-text margin-top-s">
                                    <span class="info-text-mlg bold text-color-primary">Notes</span>
                                </div>
                                <div *ngFor="let fc of faqCategories"
                                    class="list-item list-item-padding transparent-bg">
                                    <div *ngFor="let e of fc.faqEntries"
                                        class="list-item list-item-padding transparent-bg">
                                        <plain-entry-expand [e]="e" [fixed]="true"></plain-entry-expand>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ion-row>
                            <ion-col size="2">
                                <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                                    (click)="openFBPage()">
                                    <!-- <span class="button-font-size-s">Facebook</span> -->
                                    <icon-wrapper slot="icon-only" icon="logo-facebook">
                                    </icon-wrapper>
                                </ion-button>
                            </ion-col>
                            <ion-col size="8">
                                <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                                    (click)="openWebpage()">
                                    <icon-wrapper slot="icon-only" icon="globe">
                                    </icon-wrapper>
                                </ion-button>
                            </ion-col>
                            <ion-col size="2">
                                <ion-button class="as-text full-w element-selector height-auto text-transform-none"
                                    (click)="contact()">
                                    <!-- <span class="button-font-size-s">Email</span> -->
                                    <icon-wrapper slot="icon-only" icon="mail">
                                    </icon-wrapper>
                                </ion-button>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="12">
                                <ion-button class="as-text element-selector height-auto text-transform-none"
                                    (click)="openWebpage()">
                                    <span class="button-font-size-s">www.leplace.online</span>
                                </ion-button>
                            </ion-col>
                        </ion-row>

                    </div>
                </div>
            </div>
        </div>
    </div>
</ion-content>